import timeToXPosition from '../../utils/timeToXPosition';

export default (item, currentDay) => {
  const startTime = item.startDateTime;
  const endTime = item.endDateTime;

  if (item.startDate !== item.endDate) {
    const isFirstDay = item.startDate === currentDay;

    if (!isFirstDay) {
      return {
        width: timeToXPosition(endTime),
        x: 0,
      };
    }
  }

  if (!startTime || !endTime) {
    return {
      width: 100,
      x: 0,
    };
  }

  const x = timeToXPosition(startTime);
  const endX = timeToXPosition(endTime);
  let width = endX - x;

  if (width < 0) {
    width = 100 - x;
  }

  return { width, x };
};



// WEBPACK FOOTER //
// ./src/components/DayModal/getItemPosition.js